export enum AutomotiveAftermarketReportName {
  DeliveryNote = 'deliveryNote',
  HandlingUnit = 'handlingUnit',
}
